import {
  isIframe,
  sendPostMessageIframe,
  SDK__ON_FINISH,
} from '../iframeBridge/iframeBridge';

export const IFRAME_TERMINAL_DISPLAY_MS = 2000;

export const IFRAME_NAVIGATE_AFTER_FINISH_MS = 2000;

export const notifyTerminal = ({
  isCompleted,
  redirectUrl,
  processId,
  token,
  onFinalize,
  onNavigate,
  deps = {},
} = {}) => {
  const _isIframe = deps.isIframe || isIframe;
  const _postMessage = deps.sendPostMessageIframe || sendPostMessageIframe;
  const _setTimeout = deps.setTimeout || setTimeout;
  const _clearTimeout = deps.clearTimeout || clearTimeout;

  const navigate = () => {
    if (typeof onNavigate === 'function') onNavigate();
  };

  if (redirectUrl && !_isIframe()) {
    navigate();
    window.location.href = redirectUrl;
    return undefined;
  }

  if (isCompleted && !redirectUrl && !_isIframe()) {
    navigate();
    return undefined;
  }

  const finalize = () => {
    if (typeof onFinalize === 'function') onFinalize();
    _postMessage(SDK__ON_FINISH, {
      transaction: {
        id: processId,
        token: token ? token.slice(-10) : undefined,
        concluded: isCompleted,
      },
    });
  };

  if (_isIframe()) {
    let navigateId;
    const finishId = _setTimeout(() => {
      finalize();
      navigateId = _setTimeout(navigate, IFRAME_NAVIGATE_AFTER_FINISH_MS);
    }, IFRAME_TERMINAL_DISPLAY_MS);

    return () => {
      _clearTimeout(finishId);
      if (navigateId) _clearTimeout(navigateId);
    };
  }

  navigate();
  finalize();
  return undefined;
};
